import './App.scss';
import Home from './pages/Home';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { TranslationProvider } from './i18n/useTranslation';

import Contactus from './pages/Contact/Contactus';
import ServicesPage from './pages/Services';
import FeaturesPage from './pages/Features';
import AccreditedPage from './pages/Accredited';
import AppointmentPage from './pages/Appointment';
import BlogPost from './pages/BlogPost';

// Wrapper to extract `lang` from URL pathname and pass it down as prop
const LangWrapper = ({ Component }) => {
  const location = useLocation();
  const pathname = location.pathname;
  // Extract language from pathname (e.g., "/en/services" -> "en", "/ar" -> "ar")
  const langMatch = pathname.match(/^\/(en|ar)(\/|$)/);
  const currentLang = langMatch && langMatch[1] === 'ar' ? 'ar' : 'en';
  return (
    <TranslationProvider lang={currentLang}>
      <Component lang={currentLang} />
    </TranslationProvider>
  );
};

function App() {
  return (
    <Routes>
      {/* Redirect bare root to English by default */}
      <Route path="/" element={<Navigate to="/en" replace />} />

      {/* Language-aware routes - explicit routes to avoid conflicts */}
      <Route path="/en" element={<LangWrapper Component={Home} />} />
      <Route path="/ar" element={<LangWrapper Component={Home} />} />
      
      <Route path="/en/contact" element={<LangWrapper Component={Contactus} />} />
      <Route path="/ar/contact" element={<LangWrapper Component={Contactus} />} />
      
      <Route path="/en/services" element={<LangWrapper Component={ServicesPage} />} />
      <Route path="/ar/services" element={<LangWrapper Component={ServicesPage} />} />
      
      <Route path="/en/features" element={<LangWrapper Component={FeaturesPage} />} />
      <Route path="/ar/features" element={<LangWrapper Component={FeaturesPage} />} />
      
      <Route path="/en/accredited" element={<LangWrapper Component={AccreditedPage} />} />
      <Route path="/ar/accredited" element={<LangWrapper Component={AccreditedPage} />} />
      
      <Route path="/en/appointment" element={<LangWrapper Component={AppointmentPage} />} />
      <Route path="/ar/appointment" element={<LangWrapper Component={AppointmentPage} />} />
      
      {/* Blog posts - dynamic routes */}
      <Route path="/en/blog/:slug" element={<LangWrapper Component={BlogPost} />} />
      <Route path="/ar/blog/:slug" element={<LangWrapper Component={BlogPost} />} />

      {/* Fallback: any unknown route goes to default language home */}
      <Route path="*" element={<Navigate to="/en" replace />} />
    </Routes>
  );
}

export default App;
